import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormField, FormFieldOption } from '../../../../dto/util/form-field';
import { ListasService } from '../../../../services/listas.service';
import { Constants } from '../../../../constants/constants';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { ListaValorResponseDto } from '../../../../dto/tramites/lista_valor.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { combineLatest } from 'rxjs';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { TranslateService } from '@ngx-translate/core';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { DemandadoAuxDto } from "../../../../dto/tramites/demandado-aux.dto";
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-sfc-detalle',
  templateUrl: './sfc-detalle.component.html',
  styleUrl: './sfc-detalle.component.scss'
})
export class SfcDetalleComponent implements OnInit, OnChanges {
  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  archivoPrecargadoPoderJudicial?: AnexoPrecargaResponseDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
    anexos?: AnexoPrecargaResponseDto[];
  }>();
  @Input() volver: boolean = false;
  @Output() detalleEmit = new EventEmitter<{
    formDetalleRequest?: FormGroup;
    formDetalleRequestTramite?: FormGroup;
  }>();

  public formRequest: FormGroup = new FormGroup({});
  public formRequestTramite: FormGroup = new FormGroup({});
  public entidadId: number = Constants.ID_ENTIDAD_SUPERFINANCIERA;
  public formFields: FormField[] = [];
  public formFieldsTramite: FormField[] = [];
  public tipoTramite: number = Constants.TRAMITES.SUPER_FINANCIERA;
  public idTramite = 0;
  public enviarDocumentos = false;
  public allowSaveAll = true;
  private dataUsuario: PersonaLoginDTO;

  //Listas Valor
  listaCanal: ListaValorResponseDto[] = [];
  listaMotivoInconformidad: ListaValorResponseDto[] = [];
  listaProducto: ListaValorResponseDto[] = [];
  enviar = false;


  archivosCargados: ArchivoItemDto[] = [];
  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};
  // anexos para tramite
  anexosTramiteObligatorios: TipoAnexoTipoTramiteDto[] = [];

  // Paises
  paises: PaisDto[] = [];
  // seteo inputs otro Departamento y municipio
  auxIdCountry: number[] = [];

  confirmacionEnvio: boolean = false;
  enviarCorreoDemandado: boolean = false;
  demandadoAux: DemandadoAuxDto = {};
  pesoTotalArchivosMB: string = '0.00';
  seleccionAceptoRechazoEnvio = false;

  // Listas de ids documentos requeridos por pasos
  idsFilesPasoDetalle: TipoAnexoTipoTramiteDto[] = [];
  nombreTramite = '';

  constructor(
    private readonly listasService: ListasService,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    this.getListas();
  }

  buildFields() {
    this.formFields = [
      {
        isSubtitle: true,
        subtitleText: this.sfcText['sfc-procon']['detalle-inconformidad'],
        name: 'subTitle',
        required: false,
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'inconformidadExterior',
        label: this.sfcText['sfc-procon']['inconformidad-exterior'],
        type: 'radio',
        required: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
        },
      },
      {
        name: 'producto',
        label: this.sfcText['sfc-procon']['producto'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['producto-required'],
        },
      },
      {
        name: 'motivo',
        label: this.sfcText['sfc-procon']['motivo'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['motivo-required'],
        },
      },
      {
        name: 'detalleInconformidad',
        label: this.sfcText['sfc-procon']['detalle-inconformidad-producto'],
        type: 'text',
        required: false,
        placeholder:
          this.sfcText['sfc-procon'][
          'detalle-inconformidad-producto-placeholder'
          ],
        width: '12',
        visible: true,
        validation: [Validators.maxLength(100)],
        noConvertToUpperCase: true,
        errorMessages: {
          maxlength:
            this.sfcText['sfc-procon'][
            'detalle-inconformidad-producto-maxlength'
            ],
        },
      },
      {
        name: 'canal',
        label: this.sfcText['sfc-procon']['canal-reclamo'],
        type: 'select',
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['canal-required'],
        },
      },
      {
        name: 'detalleHechos',
        label: this.sfcText['sfc-procon']['detalle-hechos'],
        type: 'textarea',
        required: true,
        placeholder: this.sfcText['sfc-procon']['detalle-hechos-placeholder'],
        width: '12',
        visible: true,
        noConvertToUpperCase: true,
        validation: [Validators.maxLength(4500)],
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
          maxlength: this.sfcText['sfc-procon']['detalle-hechos-maxlength'],
        },
      },
      {
        name: 'pretenciones',
        label: this.sfcText['sfc-procon']['pretenciones'],
        type: 'textarea',
        required: true,
        placeholder: this.sfcText['sfc-procon']['detalle-hechos-placeholder'],
        width: '12',
        visible: true,
        noConvertToUpperCase: true,
        validation: [Validators.maxLength(4500)],
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
          maxlength: this.sfcText['sfc-procon']['detalle-hechos-maxlength'],
        },
      },
    ];

    this.formFieldsTramite = [
      {
        isSubtitle: true,
        subtitleText: this.sfcText['sfc-procon']['subtritulo-informacion'],
        name: 'subTitle',
        label: '',
        type: 'text',
        required: false,
        visible: true,
      },
      {
        name: 'ingresaCuantia',
        label: this.sfcText['sfc-procon']['ingresa-cuantia'],
        type: 'radio',
        required: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['campo-requerido'],
        },
      },
      {
        name: 'cuantia',
        label: this.sfcText['sfc-procon']['cuantia'],
        type: 'text',
        required: false,
        placeholder: 'Ej. 500000',
        width: '6',
        visible: false,
        maxLength: '19',
        validation: [Validators.pattern(/^\d+$/), Validators.maxLength(20)],
        errorMessages: {
          required: this.sfcText['sfc-procon']['cuantia-required'],
          pattern: this.sfcText['sfc-procon']['cuantia-pattern'],
          maxlength: this.sfcText['sfc-procon']['cuantia-valor-maximo'],
        },
        dependsOn: 'ingresaCuantia',
        visibilityCondition: value => {
          return (value as string)?.toString() == '1';
        },
      },
      {
        name: 'indemnizacion',
        label: this.sfcText['sfc-procon']['indemnizacion'],
        type: 'radio',
        required: true,
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sfcText['sfc-procon']['indemnizacion-required'],
        },
      },
      {
        name: 'juramento',
        label: this.sfcText['sfc-procon']['juramento'],
        type: 'textarea',
        required: false,
        width: '12',
        visible: false,
        placeholder: this.sfcText['sfc-procon']['detalle-hechos-placeholder'],
        validation: [Validators.maxLength(4500)],
        errorMessages: {
          required: this.sfcText['sfc-procon']['juramento-required'],
          maxlength: this.sfcText['sfc-procon']['detalle-hechos-maxlength'],
        },
        dependsOn: 'indemnizacion',
        visibilityCondition: value => {
          return (value as string)?.toString() == '1';
        },
      },
    ];
  }


  ngOnInit(): void {
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sfcText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildFields();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc'].currentValue;
    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      if (tramite.producto != undefined) {
        this.enviar = false;
        this.archivosPreCargados = tramite.anexos;
        this.formFields = this.formFields.map(field => {
          switch (field.name) {
            case 'inconformidadExterior':
              field.value = tramite.ocurrioExtranjero ? 1 : 2;
              break;
            case 'producto':
              field.value = tramite.producto?.id;
              break;
            case 'motivo':
              field.value = tramite.motivoInconformidad?.id;
              break;
            case 'detalleInconformidad':
              field.value = tramite.detalleInconformidad;
              break;
            case 'canal':
              field.value = tramite.canal?.id;
              break;
            case 'detalleHechos':
              field.value = tramite.descripcionHechos;
              break;
            case 'pretenciones':
              field.value = tramite.descripcionPretenciones;
              break;
          }
          return field;
        });
        this.formFieldsTramite = this.formFieldsTramite.map(field => {
          switch (field.name) {
            case 'ingresaCuantia':
              field.value = tramite.cuantia ? Number(tramite.conCuantia) : 2;
              break;
            case 'cuantia':
              field.value = tramite.cuantia;
              break;
            case 'indemnizacion':
              field.value = tramite.juramentoEstimatorio ? Number(tramite.conIndemnizacion) : 2;
              break;
            case 'juramento':
              field.value = tramite.juramentoEstimatorio;
              break;
          }
          return field;
        });
      }
    }
  }

  setValueForm(fieldName: string, form: FormField[], value: any) {
    const field = form.find(item => item.name == fieldName);
    if (field) {
      field.value = value;
    }
  }

  public getListas() {

    this.listasService
      .listaValor(Constants.LISTAS.SFC_MOTIVO)
      .subscribe(response => {
        this.listaMotivoInconformidad = response as ListaValorResponseDto[];
        const opt: FormFieldOption[] = this.listaMotivoInconformidad.map(
          item => ({
            Id: item.Id ?? '',
            Nombre: item.Valor ?? '',
          })
        );

        this.setValueLists('motivo', opt);
      });

    this.listasService
      .listaValor(Constants.LISTAS.SFC_PRODUCTO)
      .subscribe(response => {
        this.listaProducto = response as ListaValorResponseDto[];
        const opt: FormFieldOption[] = this.listaProducto.map(item => ({
          Id: item.Id ?? '',
          Nombre: item.Valor ?? '',
        }));
        this.setValueLists('producto', opt);
      });

    this.listasService
      .listaValor(Constants.LISTAS.SFC_CANAL)
      .subscribe(response => {
        this.listaCanal = response as ListaValorResponseDto[];
        const opt: FormFieldOption[] = this.listaCanal.map(item => ({
          Id: item.Id ?? '',
          Nombre: item.Valor ?? '',
        }));

        this.setValueLists('canal', opt);
      });
  }

  setValueLists(fieldName: string, options: FormFieldOption[]) {
    const field = this.formFields.find(item => item.name == fieldName);
    if (field) {
      field.options = options;
    }
  }


  validateForm(form: FormGroup) {
    this.formRequest = form;
  }

  validarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    this.enviarFormDetalle(formGroup, this.formRequestTramite);
  }

  onSubmitTramite(form: FormGroup) {
    this.formRequestTramite = form;

    // this.confirmacionEnvio = form.get('juramento')?.value === 1;
  }

  validarFormularioTramite($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    // Habilita cuantia como requerido
    if (formGroup?.get('ingresaCuantia')?.value == 1) {
      this.setFieldForm(this.formFieldsTramite, 'cuantia', true);
    } else {
      this.setFieldForm(this.formFieldsTramite, 'cuantia', false);
    }
    // Habilitajuramento como requerido
    if (formGroup?.get('indemnizacion')?.value == 1) {
      this.setFieldForm(this.formFieldsTramite, 'juramento', true);
    } else {
      this.setFieldForm(this.formFieldsTramite, 'juramento', false);
    }
    this.enviarFormDetalle(this.formRequest, formGroup);
  }

  setFieldForm(form: FormField[], nameField: string, flag: boolean) {
    form.forEach(field => {
      if (field.name == nameField) {
        field.required = flag;
      }
    })
    if (flag) {
      this.formRequestTramite?.get(nameField)?.addValidators(Validators.required);
    } else {
      this.formRequestTramite?.get(nameField)?.removeValidators(Validators.required);
    }
    this.formRequestTramite?.get(nameField)?.updateValueAndValidity();
  }


  mapToDTO() {
    const canal = this.listaCanal.find(
      item => item.Id === this.formRequest.value['canal']
    );

    const motivoInconformidad = this.listaMotivoInconformidad.find(
      item => item.Id === this.formRequest.value['motivo']
    );

    const producto = this.listaProducto.find(
      item => item.Id === this.formRequest.value['producto']
    );

    const tramite: TramiteSuperfinancieraDto = {
      id: this.tramiteSfc?.id,
      paso: 4,
      ocurrioExtranjero: this.formRequest.value['inconformidadExterior'] === 1,
      producto: {
        valor: producto?.Valor,
        estado: producto?.Estado,
        nombreLista: producto?.Nombre_Lista,
        codigo: producto?.Codigo,
        otroValor: producto?.Otro_valor,
        idExterno: producto?.Id_Externo,
        id: producto?.Id,
      },
      motivoInconformidad: {
        valor: motivoInconformidad?.Valor,
        estado: motivoInconformidad?.Estado,
        nombreLista: motivoInconformidad?.Nombre_Lista,
        codigo: motivoInconformidad?.Codigo,
        otroValor: motivoInconformidad?.Otro_valor,
        idExterno: motivoInconformidad?.Id_Externo,
        id: motivoInconformidad?.Id,
      },
      detalleInconformidad: this.formRequest.value['detalleInconformidad'],
      canal: {
        valor: canal?.Valor,
        estado: canal?.Estado,
        nombreLista: canal?.Nombre_Lista,
        codigo: canal?.Codigo,
        otroValor: canal?.Otro_valor,
        idExterno: canal?.Id_Externo,
        id: canal?.Id,
      },
      descripcionHechos: this.formRequest.value['detalleHechos'],
      descripcionPretenciones: this.formRequest.value['pretenciones'],

      conCuantia: this.formRequestTramite.value['ingresaCuantia'] === 1,
      cuantia: this.formRequestTramite.value['cuantia'],
      conIndemnizacion: this.formRequestTramite.value['indemnizacion'] === 1,
      juramentoEstimatorio: this.formRequestTramite.value['juramento'],
      idTipoTramite: this.tramiteSfc?.data?.Id_Tipo_Tramite ?? Constants.TRAMITES.SUPER_FINANCIERA,
      usuario: { id: this.dataUsuario.idUsuario },
      esParcial: true,
      enviar: this.enviar,
    };
    return tramite;
  }

  pasarAReclamo(e: Event, guardarSinEnviar: boolean) {
    if (this.formRequest.invalid || this.formRequestTramite.invalid) {

      this.formRequest.markAllAsTouched();
      this.formRequestTramite.markAllAsTouched();

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );

      return;
    }

    const tramite = this.mapToDTO();
    if (!guardarSinEnviar) {
      let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
      if (paso) {
        sessionStorage.setItem(Constants.PASOS, JSON.stringify(5));
      }
      this.continuar.emit({
        tramite: tramite,
        formValid: this.disabledBoton(),
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid: this.disabledBoton(),
        event: e,
      });
    }
    this.enviarDocumentos = true;
  }

  atras() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  // Archivos
  subirArchivo(resultado: boolean) {
    this.enviarDocumentos = false;
  }

  getFilesPrecargadosByPaso(paso: number): AnexoPrecargaResponseDto[] {
    return this.archivosPreCargados?.filter(
      (elemento) => elemento.tipoAnexoTipoTramite.orden === paso
    ) || [];
  }

  getFileRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    if (evento.paso == 4) {
      this.idsFilesPasoDetalle = this.searchRequired(evento.archivos);
    }
  }

  searchRequired(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }


  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    return requeridosFull === cantidadRequeridos;
  }

  validarArchivosCargados(archivos: ArchivoItemDto[], paso: number) {
    if (paso == 4) {
      this.archivosCargados = archivos;
    }
    const anexosRequeridosIds = this.idsFilesPasoDetalle.map(
      (anexo: any) => anexo.id
    );

    const totalBytes = this.archivosCargados.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);

    return this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);

  }

  disabledBoton(): boolean {
    if (this.formRequest.valid && this.formRequestTramite.valid) {
      return false;
    } else {
      return true;
    }
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  enviarFormDetalle(formRequest?: FormGroup, formRequestTramite?: FormGroup) {
    this.detalleEmit.emit({
      formDetalleRequest: this.formRequest?.valid ? formRequest : undefined,
      formDetalleRequestTramite: this.formRequestTramite?.valid ? formRequestTramite : undefined,
    });
  }
}

